import {useGameStore} from '../GameStoreContext'

export const useHasOnlyOneHumanPlayer = () => {
    const userStates = useGameStore((state) => state.gameUserStates.userStates)
    return userStates.filter((userState) => !userState.isBot).length === 1
}
